import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function ProblemSection() {
  return <section className="border-t border-white/5 bg-void-900 py-24 md:py-32" data-id="element-181" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-182" data-mp="30hhah9mrbvyo">
        <Reveal data-id="element-183" data-mp="30jaml4g538e2">
          <SectionLabel data-id="element-184" data-mp="2vqhi8hol222i">Lo que nadie te dice</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-185" data-mp="2vownaqycwh44">
            A veces sientes que algo no encaja.
          </h2>
        </Reveal>

        <div className="mt-10 space-y-7 text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-186" data-mp="35fivw17no7db">
          <Reveal delay={0.05} data-id="element-187" data-mp="3jeqxt1v7dtl7">
            <p data-id="element-188" data-mp="3jdzb6gjl3672">
              Vas, vienes, cumples horarios, respondes mensajes, sigues la rutina… pero por
              dentro hay un vacío que no sabes nombrar. Una sensación extraña de que la vida
              debería ser más que esto.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-189" data-mp="1k4irukvitp1l">
            <p data-id="element-190" data-mp="1k5aps2clbyv1">
              Sientes que el miedo te frena. Que repites pensamientos que no son tuyos. Que tus
              decisiones, en realidad, fueron programadas hace tiempo por alguien más: la
              sociedad, la familia, la cultura, el algoritmo.
            </p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-191" data-mp="sbyts02z9luq">
            <p className="font-display text-2xl italic leading-snug text-bone-100 sm:text-3xl" data-id="element-192" data-mp="x51rmkesfhgq">
              Y entonces aparece esa pregunta incómoda: “¿Y si nada de esto es lo que parece?”
            </p>
          </Reveal>
          <Reveal delay={0.2} data-id="element-193" data-mp="171ehf777pb67">
            <p className="neon-text text-gold-400" data-id="element-194" data-mp="174skkhnp9oep">
              Si has sentido eso, no estás loco. No estás solo. Estás despertando.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}